import React from 'react';
import { ChevronRight, PhoneCall } from 'lucide-react';
import { Button } from '../components/ui/button';

const HeroSection = ({ t, scrollToSection }) => (
  <section id="home" className="pt-24 pb-16 bg-gradient-to-br from-blue-950 via-gray-900 to-blue-900">
    <div className="container mx-auto px-4">
      <div className="grid md:grid-cols-2 gap-12 items-center">
        <div className="text-white">
          {/* Free Consultation Badge */}
          <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-green-500 to-emerald-600 text-white px-4 py-2 rounded-full mb-4 animate-pulse shadow-lg">
            <PhoneCall className="h-5 w-5" />
            <span className="font-semibold text-sm">
              {t.free_consultation || 'FREE CONSULTATION AVAILABLE'}
            </span>
          </div>
          
          <h1 className="text-4xl md:text-5xl font-bold mb-4" style={{ fontFamily: 'Crimson Text, serif' }}>{t.hero_title}</h1>
          <h2 className="text-3xl md:text-4xl mb-2">{t.hero_subtitle}</h2>
          <p className="text-xl text-amber-400 mb-2">{t.hero_designation}</p>
          <div className="text-sm text-gray-300 mb-6 space-y-1">
            <p>Bar Council Enrollment: UP03008</p>
            <p>COP No. 286647</p>
          </div>
          <p className="text-gray-300 mb-8 text-lg leading-relaxed">{t.hero_description}</p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Button onClick={() => scrollToSection('consultation')} size="lg" className="bg-amber-600 hover:bg-amber-700">
              {t.hero_cta}
              <ChevronRight className="ml-2 h-5 w-5" />
            </Button>
            <Button onClick={() => scrollToSection('about')} size="lg" variant="outline" className="text-white border-white hover:bg-white hover:text-blue-900">
              {t.hero_learn_more}
            </Button>
          </div>
        </div>
        <div className="flex justify-center">
          <img 
            src="https://customer-assets.emergentagent.com/job_highcourt-law/artifacts/uvzlfvnd_1000771271.jpg" 
            alt="Advocate Imran Pathan" 
            className="rounded-lg shadow-2xl w-full max-w-md object-cover"
            style={{ maxHeight: '500px' }}
          />
        </div>
      </div>
    </div>
  </section>
);

export default HeroSection;
